import { Component } from '@theme/component';

/**
 * Story slider that mimics Instagram's "ring" pattern: every item starts as unread,
 * and is flagged as viewed once the user taps it. The viewed state lives only in
 * memory, so a page reload resets every story back to the unread color.
 *
 * @extends {Component<{}>}
 */
class CollectionStorySliderComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#markViewed);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#markViewed);
  }

  /** @param {Event} event */
  #markViewed = (event) => {
    const target = /** @type {Element | null} */ (event.target);
    const item = target?.closest('.collection-story-slider__item');
    if (item) item.classList.add('collection-story-slider__item--viewed');
  };
}

if (!customElements.get('collection-story-slider-component')) {
  customElements.define('collection-story-slider-component', CollectionStorySliderComponent);
}
